import {
  BaseFormState,
  BaseFormAction,
  BaseState,
  BaseAction,
  BaseOrderlessState,
  BaseOrderlessAction
} from './types';

export const baseFormReducer = <T extends BaseFormState>(state: T, action: BaseFormAction): T => {
  switch (action.type) {
    case 'addressError':
    case 'contactOption':
    case 'contactOptionError':
    case 'email':
    case 'generalError':
    case 'hasError':
    case 'isLoading':
      return { ...state, [action.type]: action.value };
    default:
      return state;
  }
};

export const baseReducer = <T extends BaseState>(state: T, action: BaseAction): T => {
  switch (action.type) {
    case 'address':
    case 'order':
      return { ...state, [action.type]: action.value };
    default:
      return state;
  }
};

export const baseOrderLessReducer = <T extends BaseOrderlessState>(
  state: T,
  action: BaseOrderlessAction
): T => {
  switch (action.type) {
    case 'name':
    case 'phone':
      return { ...state, [action.type]: action.value };
    default:
      return state;
  }
};
